import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import { branchTransferStudents, getBranchData } from "../../api/BranchService";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { courseList } from "../../api/Courses";
import Master from "./Master";
import TransferBranchLayout from "./TransferBranchLayout";

export default function StudentTransferBranch() {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);

  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [branches, setBranches] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const handleSelectStudent = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const handleTransfer = async () => {
    try {
      const payload = {
        student_ids: selectedStudents,
        to_branch_id: filters.branch_id,
        from_batch_id: filters.batch_id,
      };

      console.log(payload);

      const res = await branchTransferStudents(payload);

      if (res?.data?.status) {
        alert("Students transferred successfully");

        setSelectedStudents([]);
      } else {
        alert(res?.data?.message);
      }
    } catch (err) {
      console.log(err);
      alert("Error while transfer");
    }
  };

  const [filters, setFilters] = useState({
    session_id: "",
    course_id: "",
    batch_id: "",
    branch_id: "",
  });

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
    setFilters({
      ...filters,
      session_id: parseSessions?.find((s) => s.status === "1")?.id,
    });
  }, []);

  useEffect(() => {
    if (filters.session_id && filters.course_id) {
      fetchBatches();
    } else {
      setBatches([]);
    }
  }, [filters.session_id, filters.course_id]);

  useEffect(() => {
    if (filters.batch_id) {
      getBatchInfo();
    }
  }, [filters.batch_id]);

  const fetchCourses = async () => {
    try {
      const res = await courseList();
      setCourses(res?.data?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const getBatchInfo = async () => {
    setLoading(true);
    try {
      let addUrl = `id=${filters.batch_id}`;

      const response = await batchDetailsWithStudents(addUrl);

      if (response.data.status) {
        setStudents(response?.data?.data?.active_batch_students || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filters.course_id) {
      fetchBatches();
    }
  }, [filters.course_id]);

  useEffect(() => {
    fetchCourses();
    fetchBranch();
  }, []);

  const fetchBatches = async () => {
    try {
      setLoading(true);

      const res = await batchList(
        `session_id=${filters.session_id}&course_id=${filters.course_id}`,
      );

      setBatches(res?.data?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBranch = async () => {
    try {
      setLoading(true);

      const res = await getBranchData();

      setBranches(res?.data?.data?.branches || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <TransferBranchLayout />

                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h4 className="text-primary mb-0">
                            Student Transfer
                          </h4>
                        </div>

                        <div className="row g-3 mb-4">
                          {/* 🔹 FROM SECTION */}
                          <div className="col-md-12">
                            <div className="card border-primary p-3">
                              <h6 className="text-primary mb-3">From</h6>

                              <div className="row g-3">
                                {/* Session */}
                                <div className="col-md-4 form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={filters?.session_id || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        session_id: e.target.value,
                                        batch_id: "",
                                      })
                                    }
                                  >
                                    <option value="">All Session</option>
                                    {sessions.map((item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.session}
                                      </option>
                                    ))}
                                  </select>
                                  <label>Session</label>
                                </div>

                                {/* Course */}
                                <div className="col-md-4 form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={filters?.course_id || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        course_id: e.target.value,
                                        batch_id: "",
                                      })
                                    }
                                  >
                                    <option value="">All Course</option>
                                    {courses.map((item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.title}
                                      </option>
                                    ))}
                                  </select>
                                  <label>Course</label>
                                </div>

                                {/* Batch */}
                                <div className="col-md-4 form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={filters?.batch_id || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        batch_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">All Batch</option>

                                    {batches.map((item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.title} ({item.course?.title})
                                      </option>
                                    ))}
                                  </select>
                                  <label>Batch</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 🔥 TO SECTION */}
                          <div className="col-md-12">
                            <div className="card border-success p-3">
                              <h6 className="text-primary mb-3">
                                To (Transfer)
                              </h6>

                              <div className="row align-items-end">
                                {/* Branch */}
                                <div className="col-md-4 form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={filters?.branch_id || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        branch_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">Select Branch</option>
                                    {branches.map((item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label>Transfer To Branch</label>
                                </div>

                                {/* Button */}
                                <div className="col-md-4">
                                  <button
                                    className="btn btn-primary"
                                    disabled={
                                      selectedStudents.length === 0 ||
                                      !filters.branch_id
                                    }
                                    onClick={handleTransfer}
                                  >
                                    Transfer ({selectedStudents.length})
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>SR No.</th>
                                <th>Title</th>
                                <th>Mobile</th>
                                <th>Admission Date</th>
                                <th>Address</th>
                              </tr>
                            </thead>

                            <tbody>
                              {students.length > 0 ? (
                                students.map((item, index) => {
                                  const s = item?.student_info || {};

                                  return (
                                    <tr key={item.id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={selectedStudents.includes(
                                            item.id,
                                          )}
                                          onChange={() =>
                                            handleSelectStudent(item.id)
                                          }
                                        />
                                      </td>
                                      <td>{index + 1}</td>

                                      <td>
                                        {s.name || "-"} (
                                        {s.registration_no || "-"})
                                      </td>

                                      <td>{s.phone || "-"}</td>

                                      <td>
                                        {s.admission_date
                                          ? new Date(
                                            s.admission_date,
                                          ).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          })
                                          : "-"}
                                      </td>

                                      <td>{s.village || "-"}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No Students Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
